import * as FormUtils from './form-utils';
import Hideable from '../classes/hideable';
const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * FORM.JS
 *
 * Initialization of the validation of forms.
 */
 export default function InitForms() {

	const forms = document.querySelectorAll('form.generic-form');
	forms.forEach((form) => {
		InitForm(form);
	});
	
	const kikuForm = document.querySelector('form.kiku_form');
	if(kikuForm)
		InitKiKuForm(kikuForm);
}

function InitForm(form) {
	if (!form) 
		return;

	const successText = form.querySelector('.success-message');
	const errorText = form.querySelector('.error-message');
	const buttonSubmit = form.querySelector('.button-submit');
	let externalTarget = form.querySelector('input[name="external_target"]')?.value == "1";
    let loadingSpinner = buttonSubmit.querySelector('.animate-spin');
	let submitting = false;

	InitFileInputs(form);

	form.addEventListener('submit', (event) => {
		event.preventDefault();

		if (submitting)
			return;

		submitting = true;
		buttonSubmit.disabled = true;
		loadingSpinner.classList.remove('hidden');

		axios.post(form.action, new FormData(form))
			.then(() => {
				FormUtils.HideErrorFields(form);
				errorText.classList.add('hidden');
				successText.classList.remove('hidden');

				if(externalTarget)
					SubmitForm(form);
				else {
					loadingSpinner.classList.add('hidden');
					FormUtils.ClearAllFields(form);
				}
			})
			.catch((error) => {
				submitting = false;
				buttonSubmit.disabled = false;
				loadingSpinner.classList.add('hidden');
				successText.classList.add('hidden');

				FormUtils.HideErrorFields(form);

				if (error.response) {
					// Request made and server responded
					if(error.response.data && error.response.data.error && error.response.status == 400)
                    	FormUtils.HandleFormErrors(form, error.response.data.error);
					else errorText.classList.remove('hidden');

				} else if (error.request) {
					// The request was made but no response was received
					console.log(error.request);
					errorText.classList.remove('hidden');
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
					errorText.classList.remove('hidden');
				}
			});
	});
}

function SubmitForm(form) {
	const registerUrl = form.querySelector('input[name="register_url"]').value;
	const buttonSubmit = form.querySelector('.button-submit');
    let loadingSpinner = buttonSubmit.querySelector('.animate-spin');

	loadingSpinner.classList.remove('hidden');
	form.action = registerUrl;
	form.submit();
}

function InitKiKuForm(form) {
	const formTypeRadios = document.querySelectorAll('input[name="people__DOT__isFoundingDate"]'); // Institution Selector
	const checkboxMail = document.querySelector('input[name="keywords[]"][value="572039"]'); // Konzert-Programm per Post
    const fieldInsitution = new Hideable(form.querySelector('.field-addresses__DOT__company_name'), true, 0); // Institution Value
    const fieldStreet = new Hideable(form.querySelector('.field-addresses__DOT__street'), true, 0); // Address
    const fieldZip = new Hideable(form.querySelector('.field-addresses__DOT__zip'), true, 0); // Address
    const fieldCity = new Hideable(form.querySelector('.field-addresses__DOT__city'), true, 0); // Address
	const formElements = form.elements;

	if(!formTypeRadios | !checkboxMail)
		return;

    formTypeRadios.forEach((radio, index) => {
		if(!formElements['people__DOT__isFoundingDate'].value && index == 0)
			radio.checked = true;
        radio.addEventListener('change', () => {
			// private person = 0
			// institution = 1
            fieldInsitution.toggle(formElements['people__DOT__isFoundingDate'].value == '1');
        });
    });

	checkboxMail.addEventListener('change', () => {
		fieldStreet.toggle(checkboxMail.checked);
		fieldZip.toggle(checkboxMail.checked);
		fieldCity.toggle(checkboxMail.checked);
	});
}

function InitFileInputs(form) {
	const fileInputs = form.querySelectorAll('input[type="file"]');

	fileInputs.forEach(input => {
		input.onchange = function () {
			const id = input.id;

			let fileName = input.files.length + ' File(s)';
			switch (input.files.length) {
				case 0:
					fileName = '';
					break;
				case 1:
					fileName = input.files[0].name;
					break;
			}

			const imageElement = document.querySelector('.uploaded-image[data-input="' + id + '"]');
			const fileNameElement = document.querySelector('.file-name[data-input="' + id + '"]');

			if (imageElement) {
				if (input.files && input.files[0]) {
					var reader = new FileReader();
					reader.onload = (e) => {
						imageElement.style.backgroundImage = 'url(' + e.target.result + ')';
					};
					reader.readAsDataURL(input.files[0]);
				} else {
					imageElement.style.backgroundImage = null;
				}
			} else fileNameElement.innerHTML = fileName;
		};
	});
}